// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const USER_BASE_URL = '/api/v1/users/';

/**
 * 获取用户列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getUserList(
  params?: OA.UserListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.PaginatedResponse<OA.User>>>(USER_BASE_URL, {
    method: 'GET',
    params: params || {},
    ...(options || {}),
  });
}

/**
 * 创建用户
 * @param data 用户数据
 * @param options 请求配置
 */
export async function createUser(
  data: OA.CreateUserParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.User>>(USER_BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取用户详情
 * @param userId 用户ID
 * @param options 请求配置
 */
export async function getUserDetail(
  userId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.User>>(`${USER_BASE_URL}${userId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 更新用户信息
 * @param userId 用户ID
 * @param data 更新数据
 * @param options 请求配置
 */
export async function updateUser(
  userId: number,
  data: OA.UpdateUserParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.User>>(`${USER_BASE_URL}${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除用户
 * @param userId 用户ID
 * @param options 请求配置
 */
export async function deleteUser(
  userId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${USER_BASE_URL}${userId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 从企业微信同步用户
 * @param data 同步参数
 * @param options 请求配置
 */
export async function syncWechatUsers(
  data?: OA.SyncWechatUsersParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.SyncUsersResult>>(`${USER_BASE_URL}sync`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data || {},
    ...(options || {}),
  });
}

/**
 * 管理员重置用户密码
 * @param userId 用户ID
 * @param data 密码数据
 * @param options 请求配置
 */
export async function resetUserPassword(
  userId: number,
  data: OA.ResetPasswordParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${USER_BASE_URL}${userId}/password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 绑定企业微信账号
 * @param userId 用户ID
 * @param data 绑定参数
 * @param options 请求配置
 */
export async function bindWechatAccount(
  userId: number,
  data: OA.BindWechatParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${USER_BASE_URL}${userId}/wechat-bind`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

